// 1. URL → 언어
export function getLangFromUrl(pathname) {
  if (!pathname) return 'ko';

  if (pathname === '/en' || pathname.startsWith('/en/')) {
    return 'en';
  }

  return 'ko';
}

// 2. 브라우저에서 현재 URL 기준 언어
function getUrlLangSafe() {
  if (typeof window === 'undefined') return 'ko';
  return getLangFromUrl(window.location?.pathname || '/');
}

// 3. localStorage 읽기/쓰기 (브라우저에서만)
function getStoredLang() {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem('lang');
  } catch {
    return null;
  }
}

function setStoredLang(lang) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem('lang', lang);
  } catch {
    // storage 가득 찼거나 프라이버시 모드일 때 무시
  }
}

/**
 * 📌 전역에서 쓸 언어 결정 함수
 * - 항상 URL 기준(langSource = URL)
 * - localStorage는 URL 기준으로 덮어써서 동기화
 * - pathnameOverride를 넘기면 SSR/테스트에서도 재사용 가능
 */
export function getGlobalLang(pathnameOverride) {
  const urlLang = pathnameOverride
    ? getLangFromUrl(pathnameOverride)
    : getUrlLangSafe();

  const stored = getStoredLang();

  // stored와 URL이 다르면 URL을 기준으로 맞춰버림
  if (stored !== urlLang) {
    setStoredLang(urlLang);
  }

  return urlLang;
}
